<template>
  <nav
    class="hidden md:flex items-center h-full gap-3 text-[15px] font-medium select-none"
  >
    <!-- Каталог -->
    <NuxtLink
      to="/catalog"
      class="px-2 py-1 hover:text-pink-200 transition whitespace-nowrap"
    >
      Каталог
    </NuxtLink>

    <!-- Доставка/Оплата -->
    <NuxtLink
      to="/delivery"
      class="px-2 py-1 hover:text-pink-200 transition whitespace-nowrap"
    >
      Доставка/Оплата
    </NuxtLink>

    <!-- Контакти -->
    <NuxtLink
      to="/contacts"
      class="px-2 py-1 hover:text-pink-200 transition whitespace-nowrap"
    >
      Контакти
    </NuxtLink>
  </nav>
</template>
